(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pxu-events-grid"] && !Shopify.designMode) return;
  try {
    
class PxuEventsGrid extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.data = this.#loadData();
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  #loadData() {
    const $dataEl = this.querySelector('[data-component-data]');
    return $dataEl ? JSON.parse($dataEl.textContent) : {};
  }
}

if (!customElements.get('pxu-events-grid')) {
  customElements.define('pxu-events-grid', PxuEventsGrid);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-faq"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;
const { debounce } = window.PxuUtils;
class FaqSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.$answers = this.queryAll('[data-pxu-faq-answer]');

    this.onMount();
  }

  onMount() {
    this.initEventListeners();
    this.updateItemHeights();
  }

  onUnmount() {
    this.events.unregisterAll();
  }

  initEventListeners() {
    this.events.register(window, 'resize', debounce(
      () => this.updateItemHeights(), 200)
    );
  }

  updateItemHeights() {
    this.$answers.forEach(($answer) => {
      const openHeight = $answer.scrollHeight;
      $answer.style.setProperty('--open-height', `${openHeight}px`);
    });
  }

  onBlockSelect(event) {
    const { blockId } = event.detail;
    const $block = document.getElementById(blockId);
    const $itemTerm = $block.querySelector('[data-pxu-faq-item-term]');
    if (!$itemTerm) return;
    $itemTerm.open = true;
  }

  onBlockDeselect(event) {
    const { blockId } = event.detail;
    const $block = document.getElementById(blockId);
    const $itemTerm = $block.querySelector('[data-pxu-faq-item-term]');
    if (!$itemTerm) return;
    $itemTerm.open = false;
  }
}

document.querySelectorAll(`[data-pxu-faq]`).forEach(($section) => {
  Section.init($section, FaqSection);
});

// Export for theme editor instance management.
if (Shopify.designMode) {
  window.PxuThemeSections.FaqSection = FaqSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-shoppable-image"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;
const { debounce } = window.PxuUtils;

class Hotspot {
  OPEN_CLASS = "pxu-shoppable-image__hotspot--open";
  CLOSE_CLASS = "pxu-shoppable-image__hotspot--closed";

  constructor($el) {
    this.$hotspot = $el;
    this.$pin = $el.querySelector('[data-pxu-shoppable-image-pin]');
    this.isOpen = false;
  }

  open() {
    this.isOpen = true;
    this.$hotspot.classList.add(this.OPEN_CLASS);
  }

  close() {
    this.isOpen = false;
    this.$hotspot.classList.remove(this.OPEN_CLASS);
    this.$hotspot.classList.add(this.CLOSE_CLASS);
    setTimeout(() => {
      this.$hotspot.classList.remove(this.CLOSE_CLASS);
    }, 2000);
  }
}

class ShoppableImageSection extends Section {
  PIN_WIDTH = 30;

  constructor($root) {
    super($root);
    this.$root = $root;
    this.$interface = this.query('[data-pxu-shoppable-image-interface]');
    this.$hotspots = this.queryAll('[data-pxu-shoppable-image-hotspot]');
    this.$tooltips = this.queryAll('[data-pxu-shoppable-image-tooltip]');
    this.hotspots = [...this.$hotspots].map(($el) => new Hotspot($el));
    this.id = $root.id;
    this.data = this.loadData();

    this.onMount();
  }

  onMount() {
    this.initEventListeners();
    this.updateTooltipVw();
    this.updateHotspotAxes();
  }

  onUnmount() {
    this.events.unregisterAll();
  }

  initEventListeners() {
    this.hotspots.forEach((hotspot) => {
      this.events.register(hotspot.$hotspot, 'focusout', (e) => {
        this.handleHotspotFocusOut(e, hotspot);
      });
      this.events.register(hotspot.$pin, 'click', (e) => this.handlePinClick(e, hotspot));
    });
    this.events.register(window, 'resize', debounce(
      () => {
        this.updateTooltipVw();
        this.updateHotspotAxes();
      },
      200
    ));
  }

  handlePinClick(event, hotspot) {
    this.toggleTooltip(hotspot);
  }

  handleHotspotFocusOut(event, hotspot) {
    if (hotspot.$hotspot.contains(event.relatedTarget)) return;
    hotspot.$pin.dataset.timer = setTimeout(() => {
      hotspot.close();
    }, 0);
  }

  updateTooltipVw() {
    this.$tooltips.forEach(($tooltip) => {
      const vw = this.$root.offsetWidth;
      $tooltip.style.setProperty('--pxu-100vw', `${vw}px`);
    });
  }

  updateHotspotAxes() {
    this.$hotspots.forEach(($hotspot) => {
      let hAxis = $hotspot.style.getPropertyValue('--pxu-section-horizontal-axis-base');
      const interfaceWidth = this.$interface.offsetWidth;
      const pinWidth = this.PIN_WIDTH;
      const subAreaWidthFactor = (interfaceWidth - (pinWidth)) / interfaceWidth;
      hAxis = hAxis * subAreaWidthFactor;

      let vAxis = $hotspot.style.getPropertyValue('--pxu-section-vertical-axis-base');
      const interfaceHeight = this.$interface.offsetHeight;
      const pinHeight = this.PIN_WIDTH;
      const subAreaHeightFactor = (interfaceHeight - (pinHeight)) / interfaceHeight;
      vAxis = vAxis * subAreaHeightFactor;
      
      $hotspot.style.setProperty('--pxu-section-horizontal-axis', hAxis);
      $hotspot.style.setProperty('--pxu-section-vertical-axis', vAxis);
    });
  }

  toggleTooltip(hotspot) {
    if (hotspot.isOpen) {
      hotspot.$pin.blur();
      hotspot.close();
    } else {
      this.closeAllHotspots();
      hotspot.open();
    }
  }

  closeAllHotspots() {
    this.hotspots.forEach((hotspot) => hotspot.close());
  }

  onBlockSelect(event) {
    const { blockId } = event.detail;
    const hotspot = this.hotspots.find((hotspot) => hotspot.$hotspot.id === blockId);
    if (hotspot) hotspot.open();
  }

  onBlockDeselect(event) {
    const { blockId } = event.detail;
    const hotspot = this.hotspots.find((hotspot) => hotspot.$hotspot.id === blockId);
    if (hotspot) hotspot.close();
  }
}

document.querySelectorAll(`[data-pxu-shoppable-image]`).forEach(($section) => {
  Section.init($section, ShoppableImageSection);
});

// export for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.ShoppableImageSection = ShoppableImageSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-slideshow"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class SlideshowSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.autoplay = this.data.autoplay;
    this.autoplayDuration = this.data.autoplayDuration * 1000;
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    const options = {
      autoPlay: this.autoplay ? this.autoplayDuration : false,
      prevNextButtons: true,
      lazyLoad: true
    };

    const mobileOptions = {
      draggable: true,
      autoPlay: this.autoplay ? this.autoplayDuration : false,
      lazyLoad: true
    };

    this.carousel = new Carousel(this.$root, options, mobileOptions);
    this.carousel.onMount();
  }

  onUnmount() {
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-slideshow]').forEach(($section) => {
  Section.init($section, SlideshowSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.SlideshowSection = SlideshowSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-testimonials"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class TestimonialsSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;

    const options = {
      prevNextButtons: true,
      groupCells: 3,
      cellAlign: 'left'
    };


    const mobileOptions = {
      draggable: true,
      cellAlign: 'left'
    };

    this.carousel = new Carousel(this.$root, options, mobileOptions);
    this.carousel.onMount();
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-testimonials]').forEach(($section) => {
  Section.init($section, TestimonialsSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.TestimonialsSection = TestimonialsSection;
}

  } catch(e) { console.error(e); }
})();
})();
